<template lang="pug">
  .absolute.loading.z-100.w-full.h-full.flex.justify-center(v-if="isShow" )
    .load-bg.absolute
    .loader.loader--style2.absolute()
      .flex.items-center.justify-center.bg-white.w-200.h-200.rounded-16
        div
          .flex.justify-center.w-108.h-108
            img.w-full( src='@/assets/Success.png')
          .text-center(v-html="$xss(text)")  
</template>

<script>
// import Button from '@/components/common/Button.vue';
import { globalFixed } from '@/utils/mixin'


export default {
  name: 'Toast',
  components: {
    // Button,
  },
  props: {
    // type: String,
    // rounded: {
    //   type: String,
    //   default: '12',
    // },
    text:{
      type: String,
      default: 'Success',
    },
    show: {
      type: Boolean,
      required: true,
    },
    // headerTitle: String,
    // bodyContent: String,
    // header: String,
    // body: String,
    // footer: String,
    // clickOutSideClose: {
    //   type: Boolean,
    //   default: true,
    // },
    // padding: String,
    
  },
  mixins: [globalFixed],
  data() {
    return {
      isShow : this.show
    };
  },
  methods: {
  },
  computed: {
    // isShow: {
    //   get() {
    //     return this.show; 
    //   },
    //   set(val) {
    //       this.$emit('update:show', false);
    //     setTimeout(()=>{
    //     },1500)
    //   }
    // },
  },
  watch:{
    'show': function (n){
      
      this.isFixed(n, 'fixed');
      this.isShow = n;
      if(n){
        setTimeout(()=>{
          this.$emit('update:show', false);
        },1500)
      }
    }
  }
};
</script>

<style lang="scss" scoped>


.loading{
  @apply  fixed top-0 right-0 bottom-0 left-0 bg-modal;
  .load-bg{
    content: '';
    z-index: 0;
    width:100%;
    height: 100%;
    background-color: #838487;
    opacity: 0.5;
  }
  .loader{
    transform: translate(-50%, -50%);
    top:50%;
    left:50%;
  }
}


</style>